<template>
  <div>
    <el-row>
      <el-col :span="24">
        <Header></Header>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="4">
        <MenuList></MenuList>
      </el-col>
      <el-col :span="20">
        <div>
          <el-divider><span style="font-size: 16px;">{{action_title}}</span></el-divider>
        </div>
        <div style="padding: 10px;display: flex;justify-content: center;">
          <div style="width: 40%;border: 1px solid lightgrey;">
            <el-form ref="editForm" label-width="80px" size="mini" style="margin-top:40px;">
              <el-form-item label="分组名称">
                <el-input v-model="competition_title" placeholder="如:100道题比赛,200道题比赛"></el-input>
              </el-form-item>

              <el-form-item label="获奖标准">
                <el-input v-model="competition_category" placeholder="如:天文 地理等"></el-input>
              </el-form-item>

              <el-form-item label="奖品图片">
                <el-input v-model="complete_standard" placeholder="如:10道题 100道题"></el-input>
              </el-form-item>

              <el-form-item label="参赛费用">
                <el-input v-model="complete_standard" placeholder="如:10道题 100道题"></el-input>
              </el-form-item>



              <el-form-item size="large">
                <div style="display: flex;justify-content: center;">
                  <el-button type="primary" @click="saveCompetion()">保存</el-button>
                  <el-button @click="back">返回</el-button>
                </div>
              </el-form-item>
            </el-form>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
  import MenuList from './menu.vue'
  import Header from './head.vue'

  export default {
    components: {
      MenuList,
      Header
    },
    created() {
      this.username = this.$session.get('USERNAME') // 获取session
      this.competition_id = this.$route.params.competition_id
    },
    data() {
      return {
        competition_id:'',


        imageUrl:'',

        upload_image_url: '/score/web/_upload_competition_image.jsp',

      }
    },
    methods: {
      saveCompetion() {
        console.log(this.datetime_range[0], this.datetime_range[1])

        if (this.competition_title === '') {
          this.$message.error('请输入活动名称')
          return
        }

        if (this.competition_category === '') {
          this.$message.error('请输入活动类别')
          return
        }

        if (this.complete_standard === '') {
          this.$message.error('请输入完赛标准')
          return
        }

        if (this.datetime_range === '') {
          this.$message.error('请选择活动时间')
          return
        }

        this.start_time = this.datetime_range[0]
        this.end_time = this.datetime_range[1]

        var requestUrl = '/score/web/_competition_save.jsp'

        let that = this

        this.axios.get(requestUrl, {
            params: {
              competition_title: that.competition_title,
              competition_category: that.competition_category,
              start_time: that.start_time,
              end_time: that.end_time,
              complete_standard: that.complete_standard,
              preface_image_url:that.preface_image_url
            }
          }).then(function(response) {
            that.$message('保存成功！')
            that.$router.push('/competition_list')
          })
          .catch(function(error) {
            console.log(error)
          })
      },

      handleAvatarSuccess(res, file) {
        console.log(res)
        this.preface_image_url = res.file_name
        this.imageUrl = URL.createObjectURL(file.raw);
      },
      beforeAvatarUpload(file) {
        const fileName = file.name;
        const fileType = fileName.substring(fileName.lastIndexOf('.')).toLowerCase();
        const isOKType =
          fileType === '.jpg' ||
          fileType === '.png' ||
          fileType === '.jpeg' ||
          fileType === '.bmp' ||
          fileType === '.gif';
        if (!isOKType) {
          this.$message.error('图片格式只能为jpeg/png/jpg/bmp/gif');
        }

        const isLt2M = file.size / 1024 / 1024 < 2;
        if (!isLt2M) {
          this.$message.error('图片大小不能超过 2MB!');
        }
        return isLt2M && isOKType;
      },


      saveTeamExam() {
        let that = this

        if (this.exam_name === '') {
          this.$message.error('请输入考试名称，如：期中考试')
          return
        }

        if (this.grade === '') {
          this.$message.error('请输入年级和班级')
          return
        }

        var requestUrl = '/score/web/_team_exam_edit_save.jsp'

        this.axios.get(requestUrl, {
            params: {
              exam_id: that.examID,
              exam: that.exam_name,
              grade: that.grade,
              operation: that.operation,
              username: that.username
            }
          }).then(function(response) {
            that.$message('保存成功！')
            that.$router.push('/team_exam_list')
          })
          .catch(function(error) {
            console.log(error)
          })
      },
      back() {
        this.$router.go(-1)
      },
      loadCourses() {
        let that = this
        var requestUrl = '/score/web/_get_full_courses.jsp'

        this.axios.get(requestUrl, {
            params: {
              username: that.username
            }
          }).then(function(response) {
            that.courses = response.data
          })
          .catch(function(error) {
            console.log(error)
          })
      }
    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/competition_group_edit.vue